import { AutoAwesomeOutlined } from '@mui/icons-material'
import { CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import * as api from '../../../infrastructure/api'
import { t } from '../../../infrastructure/i18nextHelper'
import { snackbars } from '../../../infrastructure/snackbars'
import { Menu } from '../../common/customComponents'

type AnalyzeButtonProps = {
  enabled: boolean
  document: Document
  onAnalyzed: (document: DocumentAnalyzed) => void
}

export function VesselAnalyzeDocumentButton(props: AnalyzeButtonProps) {
  let [analyzing, setAnalyzing] = useState<boolean>(false);

  let analyzeDocumentAction = async (document: Document, documentType: DocumentType) => {
    if (!analyzing) {
      setAnalyzing(true)
      try {
        snackbars.info(t('vessels.label.analyzeInProgress'))
        let response = await api.post(`document/analyze/${document.associationKey}/${document.id}`, {})
        props.onAnalyzed({
          type: documentType,
          data: response.fetchResponse as VesselFormExtract
        })
      } catch (error) {
        snackbars.warning(t('vessels.label.analyzeError'))
      } finally {
        setAnalyzing(false)
      }
    }
  }

  return <Menu
    disabled={!props.enabled || analyzing}
    icon={analyzing ? <CircularProgress size={16} /> : <AutoAwesomeOutlined />}
    items={[
      { value: DocumentType.VESSEL, text: t('vessels.label.analyzeDocumentProducts') },
      { value: DocumentType.PURCHAGE_MOVEMENTS, text: t('vessels.label.analyzeDocumentMovement') }
    ]}
    onChange={newValue => analyzeDocumentAction(props.document, newValue as DocumentType)} />
}

export type Document = {
  id: string,
  associationKey: string,
}

export enum DocumentType {
  VESSEL,
  PURCHAGE_MOVEMENTS
}

export type DocumentAnalyzed = {
  type: DocumentType
  data: VesselFormExtract
}

export type VesselFormExtract = {
  vesselName: string,
  outturnDate: string,
  products: Product[]
}

export type Product = {
  productType: string,
  productOperations: ProductOperation[]
}

export type ProductOperation = {
  operationType: string,
  productType: string,
  quantities: Volume[]
}

export type Volume = {
  value: number,
  unit: string
}